/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useTriggerPlanMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";

type Props = {
  onSuccess: (id: string) => void;
};

export function useTriggerPlan({ onSuccess }: Props) {
  const [triggerPlanMutation, { client, ...rest }] = useTriggerPlanMutation({
    onCompleted: (data) => {
      if (data?.triggerPlan) {
        showSuccess(generateActionSuccessText("Plan")()("triggered")());
        onSuccess(data.triggerPlan.id);
      }
    },
    onError: (error: Error) => showError(error.message),
  });

  async function triggerPlan(id: string) {
    await triggerPlanMutation({
      variables: {
        id,
      },
    });
  }

  return [triggerPlan, { client, ...rest }] as const;
}
